import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key : "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key : "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key : "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
    {
    key : "CITY-CODE",
    value: '{{CITY-CODE}}',
    required: true
  },
];
const QueryData: any = [
  {
    param: "lat",
    value: '{{lat}}',
    required: false
  },
  {
    param: "lon",
    value: '{{lon}}',
    required: false
  },
  {
    param: "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
  "neigh_name": "",
  "property_cat_subcat": "",
  "property_sub_cat": "",
  "property_uid": "",
  "property_name": "",
  "property_grade": "",
   "parcel_uid": "",
  "paci_no": ""
}`,
    required: false
  }
]
@Component({
  selector: 'app-dallal-buildings',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ApiTitleComponent,
    ApiUIResponseComponent,
  ],
  templateUrl: './dallal-buildings.component.html'
})
export class DallalBuildingsComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService, 
          private userService: UserService, 
          private router: Router){
    
  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
        this.userService.getAllUserResource(userInfo.user_id)
          .subscribe({
            next: (res: any) => {
              const matched = res.data.find((r: any) => r.resource_name === Resource.Building);
                if (!matched?.methods?.includes(HTTPMethod.GET)) {
                  this.router.navigate(['/'])
                }
            },
            error: (err) => {
            }
          })
   }

  ngAfterViewInit(){
  }

  api_demo= `${environment.apiBaseUrl}${apiEndPoints.buildings}`;

  api_response = `
{
  "status": 0,
  "message": "string",
  "data": 
  {
    "property_uid": "LKWTAA5124",
    "lat": 29.08179801,
    "lon": 48.12884692,
    "property_name": "PACI No. 93814563",
    "neigh_name": "Fahaheel",
    "block_name": "8",
    "land_area": 1015,
    "property_grade": "grade_d",
    "build_year": "2009-01-01T00:00:00",
    "property_cat_subcat": "Multi_Story_Residential",
    "property_sub_cat": "Residential_Building",
    "parcel_uid": "PKWTBI1696",
    "floors": 8,
    "units": 33,
    "govern_name": "Ahmadi",
    "year": 2025,
    "street_name": "string",
    "zoning": "INV",
    "ref_no": "93814563",
    "parcel_no": "13",
    "project_name": "string",
    "amenities": "string",
    "survey_block": "Survey 44",
    "retail_area": 50,
    "office_area": 0,
    "residential_area": 2448,
    "parking_area": 0,
    "hospitality_area": 0,
    "storage_area": 0,
    "build_status": "developed",
    "far_actual": 2.5,
    "far_permissible": 2.5,
    "usage": "string",
    "property_age": 16,
    "developer": "string",
    "construction_expected_date": "2025-09-11T16:29:04.155Z",
    "plan_no": "29639ب-33973-34033",
    "setback_area": 2.5,
    "frontage": 3.299,
    "corner": 1,
    "direction_info": {
      "e": 16.20021442746041,
      "n": 0,
      "s": 0,
      "w": 16.101178990955198,
      "ne": 0,
      "nw": 0,
      "se": 0,
      "sw": 0
    }
  }
}`;
}
